module.exports = __webpack_public_path__ + "static/img/icon-gift2.8689e135.png";